import NotAuthorised from "./NotAuthorised";

export default NotAuthorised